<template>
  <div
    ref="paginaExtrato"
    class="pagina-extrato-bancario"
    :style="{ '--altura-util-extrato': alturaUtilExtrato }"
  >
    <b-sidebar
      id="sidebar-transferencia"
      v-model="mostrarTransferencia"
      backdrop-variant="dark"
      backdrop
      right
      shadow
      :no-header-close="isSavingTransferencia"
      :no-close-on-backdrop="isSavingTransferencia"
      :no-close-on-esc="isSavingTransferencia"
    >
      <div class="px-2 py-2">
        <div style="width: 100%" class="p-2">
          <h4 class="text-dark">Transferência</h4>
          <b-form-group label="Tipo de transferência">
            <div
              class="tipo-transferencia"
              role="group"
              aria-label="Tipo de transferência"
            >
              <b-button
                type="button"
                :variant="
                  tipoTransferencia === 'contas' ? 'primary' : 'outline-primary'
                "
                :disabled="isSavingTransferencia"
                data-testid="tipo-transferencia-contas"
                @click="selecionarTipoTransferencia('contas')"
              >
                Entre contas
              </b-button>
              <b-button
                type="button"
                :variant="
                  tipoTransferencia === 'caixa' ? 'primary' : 'outline-primary'
                "
                :disabled="isSavingTransferencia"
                data-testid="tipo-transferencia-caixa"
                @click="selecionarTipoTransferencia('caixa')"
              >
                Caixa
              </b-button>
            </div>
          </b-form-group>

          <p v-if="tipoTransferencia === 'contas'">
            O valor será debitado desta conta e creditado na conta bancária de destino.
          </p>
          <p v-else>O valor será debitado desta conta e lançado como entrada no Caixa.</p>

          <b-alert
            :show="tipoTransferencia === 'caixa' && !!erroTransferenciaCaixa"
            variant="danger"
          >
            {{ erroTransferenciaCaixa }}
          </b-alert>

          <b-col md="12">
            <b-form-group
              label="Conta de origem:"
              label-for="transferencia-origem"
            >
              <div
                id="transferencia-origem"
                class="form-control h-auto bg-light"
              >
                <strong>{{ banco ? banco.nome : "" }}</strong>
                <div v-if="banco">
                  Saldo atual: R$ {{ numberToReal(banco.saldo) }}
                </div>
              </div>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Destino:" label-for="transferencia-destino">
              <b-form-select
                v-if="tipoTransferencia === 'contas'"
                id="transferencia-destino"
                v-model="transferencia.banco"
                :disabled="isSavingTransferencia"
              >
                <b-form-select-option
                  v-for="b in bancos"
                  :key="b.id_banco + 'bancos'"
                  :value="b"
                >
                  {{ b.nome }}
                </b-form-select-option>
              </b-form-select>
              <div
                v-else
                id="transferencia-destino"
                class="form-control h-auto bg-light font-weight-bold"
              >
                Caixa
              </div>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Data da transferência:"
              label-for="transferencia-data"
            >
              <b-form-input
                id="transferencia-data"
                v-model="transferencia.data_transferencia"
                type="date"
                locale="pt-br"
                required
                :min="dataMinimaTransferenciaAtual"
                :disabled="isSavingTransferencia"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Valor R$:" label-for="transferencia-valor">
              <money
                id="transferencia-valor"
                v-model="transferencia.valor"
                v-bind="configMoney"
                class="form-control"
                :disabled="isSavingTransferencia"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Observação (opcional):"
              label-for="transferencia-observacao"
            >
              <b-form-textarea
                id="transferencia-observacao"
                v-model="transferencia.observacao"
                rows="3"
                :disabled="isSavingTransferencia"
              />
            </b-form-group>
          </b-col>
        </div>
      </div>
      <template #footer>
        <div class="d-flex text-light align-items-center px-3 py-2">
          <button
            :id="
              tipoTransferencia === 'caixa'
                ? 'btn-salvar-transferencia-caixa'
                : 'btn-salvar-transferencia-contas'
            "
            ref="salvarTranferencia"
            style="width: 100%"
            class="btn btn-primary btn-hover-dark font-weight-bold"
            :disabled="isSavingTransferencia"
            :aria-busy="isSavingTransferencia"
            @click="salvarTransferenciaAtual"
          >
            <b-spinner v-if="isSavingTransferencia" small class="mr-1" />
            {{
              isSavingTransferencia
                ? "Transferindo..."
                : "Realizar transferência"
            }}
          </button>
        </div>
      </template>
    </b-sidebar>

    <b-sidebar
      id="sidebar-movimento-fields"
      backdrop-variant="dark"
      backdrop
      right
      shadow
    >
      <div class="px-2 py-2">
        <div style="width: 100%" class="p-2">
          <h4 class="text-dark">Inserir novo movimento:</h4>
          <b-col md="12">
            <b-form-group
              id="descricao"
              label-for="descricao"
              label="Descrição"
            >
              <b-form-input v-model="lancamento.descricao"> </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              id="data_movimento"
              label-for="data_movimento"
              label="Data Movimento:"
            >
              <b-form-input
                type="date"
                id="data_movimento"
                placeholder=" "
                locale="pt-br"
                v-model="lancamento.data_movimento"
                :min="dataMinimaMovimento"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group id="valor" label-for="valor" label="Valor R$:">
              <money
                class="form-control"
                v-model="lancamento.valor"
                v-bind="configMoney"
              >
              </money>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Tipo movimento:" label-for="tipo">
              <b-form-select v-model="lancamento.tipo">
                <b-form-select-option
                  v-for="t in tiposMovimento"
                  :key="t.id + 'tipo'"
                  :value="t.id"
                >
                  {{ t.descricao }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </div>
      </div>
      <template #footer="{ hide }">
        <div
          class="d-flex text-light align-items-center px-3 py-2"
          v-if="!lancamento.id_movimento"
        >
          <button
            style="width: 100%"
            ref="salvarMovimento"
            class="btn btn-primary btn-hover-dark font-weight-bold"
            @click="salvarMovimento"
          >
            Realizar Lançamento
          </button>
        </div>
        <div
          class="d-flex text-light align-items-center px-3 py-2"
          v-if="lancamento.id_movimento"
        >
          <button
            style="width: 100%"
            ref="salvarMovimento"
            class="btn btn-primary btn-hover-dark font-weight-bold"
            @click="salvarMovimento"
          >
            Atualizar Lançamento
          </button>
        </div>
      </template>
    </b-sidebar>
    <b-card tag="article" class="extrato-bancario">
      <header class="extrato-header">
        <div class="extrato-identificacao">
          <button type="button" class="btn-voltar" @click="goBack">
            <span aria-hidden="true">←</span> Contas bancárias
          </button>
          <h3 class="extrato-titulo">{{ banco ? banco.nome : "" }}</h3>
          <div class="extrato-subtitulo">Extrato bancário</div>
        </div>
        <div class="saldo-atual-conta">
          <span>Saldo atual da conta</span>
          <strong>R$ {{ numberToReal(banco ? banco.saldo : 0) }}</strong>
        </div>
        <div data-testid="acoes-conta-bancaria" class="acoes-conta-bancaria">
          <b-button
            variant="outline-success"
            aria-label="Exportar para Excel"
            v-b-tooltip.hover.bottom="'Exportar para Excel'"
            @click="exportarExtratoXLS"
          >
            <FileExcel :size="18" />
            <span>Exportar</span>
          </b-button>
          <b-button
            id="btn-transferir"
            variant="primary"
            aria-label="Transferir"
            v-b-tooltip.hover.bottom="'Transferir'"
            :disabled="
              !banco ||
              isLoading ||
              isAtualizandoBanco ||
              isSavingTransferencia ||
              !!transferenciaCaixaPendenteAtualizacao
            "
            @click="abrirTransferencia"
          >
            <SwapHorizontal :size="18" />
            <span>Transferir</span>
          </b-button>
          <b-button
            v-b-toggle.sidebar-movimento-fields
            variant="primary"
            aria-label="Novo lançamento"
            v-b-tooltip.hover.bottom="'Novo lançamento'"
            @click="lancamento = {}"
          >
            <Plus :size="18" />
            <span>Nova movimentação</span>
          </b-button>
        </div>
      </header>

      <b-alert
        :show="
          !!transferenciaCaixaPendenteAtualizacao &&
          !isLoading &&
          !isSavingTransferenciaCaixa
        "
        variant="warning"
        class="mt-3"
      >
        A transferência foi concluída, mas não foi possível atualizar o saldo e
        o extrato.
        <b-button
          size="sm"
          variant="outline-dark"
          :disabled="isLoading || isSavingTransferenciaCaixa"
          @click="atualizarExtratoTransferenciaCaixa"
        >
          Atualizar saldo e extrato
        </b-button>
      </b-alert>

      <b-row class="resumo-extrato">
        <b-col cols="12" md="6" xl="3">
          <div class="resumo-card resumo-card--anterior">
            <div class="resumo-icone">$</div>
            <div>
              <div class="resumo-label">{{ rotuloSaldoAnterior }}</div>
              <div class="resumo-valor">
                R$ {{ numberToReal(resumoExtrato.saldoAnterior) }}
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="6" xl="3">
          <div class="resumo-card resumo-card--entrada">
            <div class="resumo-icone">↑</div>
            <div>
              <div class="resumo-label">Entradas no período</div>
              <div class="resumo-valor">
                R$ {{ numberToReal(resumoExtrato.entradas) }}
              </div>
              <div class="resumo-detalhe">
                {{ resumoExtrato.quantidadeEntradas }}
                {{
                  resumoExtrato.quantidadeEntradas === 1
                    ? "movimentação"
                    : "movimentações"
                }}
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="6" xl="3">
          <div class="resumo-card resumo-card--saida">
            <div class="resumo-icone">↓</div>
            <div>
              <div class="resumo-label">Saídas no período</div>
              <div class="resumo-valor">
                R$ {{ numberToReal(resumoExtrato.saidas) }}
              </div>
              <div class="resumo-detalhe">
                {{ resumoExtrato.quantidadeSaidas }}
                {{
                  resumoExtrato.quantidadeSaidas === 1
                    ? "movimentação"
                    : "movimentações"
                }}
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="6" xl="3">
          <div class="resumo-card" :class="classeResultadoPeriodo">
            <div class="resumo-icone">=</div>
            <div>
              <div class="resumo-label">Resultado do período</div>
              <div class="resumo-valor">
                <span v-if="sinalResultadoPeriodo"
                  >{{ sinalResultadoPeriodo }} </span
                >R$
                {{ numberToReal(Math.abs(resumoExtrato.resultadoPeriodo)) }}
              </div>
              <div v-if="detalheSaldoFinal" class="resumo-detalhe">
                {{ detalheSaldoFinal }}
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

      <section class="filtros-extrato" aria-label="Filtros do extrato">
        <b-form @submit.prevent>
          <b-row align-v="end">
            <b-col cols="12" sm="6" md="4" lg="2">
              <b-form-group label="Período" label-for="periodoSelect">
                <b-form-select
                  id="periodoSelect"
                  v-model="selectedPeriodo"
                  :options="periodos"
                  @change="onPeriodChange"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" lg="2">
              <b-form-group label="Data inicial" label-for="dataInicial">
                <b-form-input
                  id="dataInicial"
                  v-model="data_inicial"
                  type="date"
                  @input="onDataPersonalizadaChange"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" lg="2">
              <b-form-group label="Data final" label-for="dataFinal">
                <b-form-input
                  id="dataFinal"
                  v-model="data_final"
                  type="date"
                  @input="onDataPersonalizadaChange"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" lg="2">
              <b-form-group label="Tipo" label-for="filtroTipo">
                <b-form-select
                  id="filtroTipo"
                  v-model="filtroTipo"
                  :options="tiposFiltro"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" lg="2">
              <b-form-group label="Status" label-for="filtroStatus">
                <b-form-select
                  id="filtroStatus"
                  v-model="filtroStatus"
                  :options="statusFiltro"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" lg="2">
              <b-form-group
                label="Descrição ou documento"
                label-for="buscaMovimento"
              >
                <b-form-input
                  id="buscaMovimento"
                  v-model.trim="buscaMovimentoInput"
                  placeholder="Buscar..."
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </section>

      <section class="bloco-listagem-extrato">
        <div class="lista-extrato-cabecalho">
          <h4>
            Movimentações
            <span>({{ tableMovimentacoes.length }} registros)</span>
          </h4>
        </div>

        <div v-if="isLoading" class="text-center py-5">
          <b-spinner variant="primary"></b-spinner>
          <p>Carregando...</p>
        </div>

        <div v-else class="bloco-tabela-extrato">
          <b-table
            v-if="tableMovimentacoes.length > 0"
            class="tabela-extrato"
            hover
            responsive
            show-empty
            :fields="fields"
            :items="itensTabelaExtrato"
            :tbody-tr-class="classeLinhaExtrato"
          >
            <template #cell(data_hora)="data">
              <span v-if="!data.item.eh_fechamento_diario" class="text-nowrap">
                {{ formatDataHoraMovimento(data.item) }}
              </span>
              <span v-else aria-hidden="true"></span>
            </template>

            <template #cell(tipo_extrato)="data">
              <span
                v-if="!data.item.eh_fechamento_diario"
                class="marcadores-extrato"
              >
                <span
                  v-b-tooltip.hover.top
                  class="badge-extrato"
                  :class="classeTipo(data.item)"
                  :title="`Tipo: ${tipoMovimento(data.item)}`"
                  :aria-label="`Tipo: ${tipoMovimento(data.item)}`"
                  >{{ siglaTipo(data.item) }}</span
                >
                <span
                  v-b-tooltip.hover.top
                  class="badge-extrato"
                  :class="classeStatus(data.item)"
                  :title="`Status: ${statusMovimento(data.item)}`"
                  :aria-label="`Status: ${statusMovimento(data.item)}`"
                  >{{ siglaStatus(data.item) }}</span
                >
              </span>
              <span v-else aria-hidden="true"></span>
            </template>

            <template #cell(descricao)="data">
              <div
                class="descricao-principal"
                :class="{
                  'descricao-fechamento': data.item.eh_fechamento_diario,
                }"
              >
                {{ descricaoApresentacao(data.item) }}
              </div>
              <div v-if="detalheMovimento(data.item)" class="descricao-detalhe">
                {{ detalheMovimento(data.item) }}
              </div>
            </template>

            <template #cell(origem)="data">
              {{
                data.item.eh_fechamento_diario ? "" : data.item.origem || "—"
              }}
            </template>

            <template #cell(destino)="data">
              {{
                data.item.eh_fechamento_diario ? "" : data.item.destino || "—"
              }}
            </template>

            <template #cell(valor_movimento)="data">
              <span
                v-if="!data.item.eh_fechamento_diario"
                class="valor-movimento"
                :class="
                  data.item.tipo_movimento === 1
                    ? 'text-success'
                    : 'text-danger'
                "
              >
                {{ data.item.tipo_movimento === 1 ? "+" : "-" }} R$
                {{ numberToReal(data.item.valor_movimento) }}
              </span>
              <span v-else aria-hidden="true"></span>
            </template>

            <template #cell(saldo_apos)="data">
              <span
                class="saldo-movimento"
                :class="
                  Number(data.item.saldo_apos) < 0
                    ? 'text-danger font-weight-bold'
                    : ''
                "
              >
                R$ {{ numberToReal(data.item.saldo_apos) }}
              </span>
            </template>

            <template #cell(acoes)="data">
              <b-button
                v-if="
                  !data.item.eh_fechamento_diario &&
                  podeEstornarTransferenciaBancoCaixa(data.item)
                "
                size="sm"
                variant="danger"
                class="btn-acao-movimento"
                :disabled="isEstornandoTransferenciaCaixa !== null"
                @click="estornarTransferenciaCaixa(data.item)"
              >
                <b-spinner
                  v-if="
                    isEstornandoTransferenciaCaixa ===
                    (data.item.id_financeiro || data.item.id_movimento)
                  "
                  small
                />
                Estornar
              </b-button>
              <b-button
                v-else-if="
                  !data.item.eh_fechamento_diario &&
                  podeEditarMovimento(data.item)
                "
                size="sm"
                variant="warning"
                class="btn-acao-movimento"
                @click="editarMovimento(data.item)"
              >
                Editar
              </b-button>
              <span
                v-else-if="!data.item.eh_fechamento_diario"
                class="acao-indisponivel"
                aria-label="Sem ações"
                >—</span
              >
              <span v-else aria-hidden="true"></span>
            </template>
          </b-table>

          <div v-else class="estado-vazio">
            Nenhuma movimentação encontrada para o período.
          </div>

          <footer class="rodape-tabela-extrato">
            <div class="rodape-registros">
              Mostrando {{ primeiroRegistroPagina }}–{{
                ultimoRegistroPagina
              }}
              de {{ tableMovimentacoes.length }} movimentações
            </div>
            <div class="rodape-paginacao">
              <b-pagination
                v-model="paginaAtual"
                :total-rows="tableMovimentacoes.length"
                :per-page="porPagina"
                size="sm"
                prev-text="‹"
                next-text="›"
                hide-goto-end-buttons
                aria-label="Paginação das movimentações"
              />
              <b-form-select
                v-model="porPagina"
                :options="opcoesPorPagina"
                size="sm"
                class="seletor-por-pagina"
                aria-label="Quantidade de movimentações por página"
              />
            </div>
          </footer>
          <div
            class="text-right font-weight-bold py-3"
            data-testid="saldo-atual-final"
          >
            Saldo atual da conta: R$ {{ numberToReal(banco ? banco.saldo : 0) }}
          </div>
        </div>
      </section>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SistemaMixin } from "@/modules/Application";
import moment from "moment";
import Plus from "vue-material-design-icons/Plus.vue";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import SwapHorizontal from "vue-material-design-icons/SwapHorizontal.vue";
import FileExcel from "vue-material-design-icons/FileExcel.vue";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "app-movimentacao-banco",
  mixins: [SistemaMixin],
  data() {
    return {
      banco: null,
      titulo: null,
      movimentacoes: [],
      data_inicial: null,
      data_final: null,
      titulo_card: null,
      fields: [
        {
          key: "data_hora",
          label: "Data/Hora",
          sortable: false,
          thClass: "text-left align-middle coluna-data-extrato",
          tdClass: "text-left align-middle coluna-data-extrato",
        },
        {
          key: "tipo_extrato",
          label: "Tipo / status",
          sortable: false,
          thClass: "text-left align-middle coluna-marcadores-extrato",
          tdClass: "text-left align-middle coluna-marcadores-extrato",
        },
        {
          key: "descricao",
          label: "Descrição",
          sortable: false,
          thClass: "text-left align-middle",
          tdClass: "text-left align-middle",
        },
        {
          key: "origem",
          label: "Origem",
          sortable: false,
          thClass: "text-left align-middle",
          tdClass: "text-left align-middle",
        },
        {
          key: "destino",
          label: "Destino",
          sortable: false,
          thClass: "text-left align-middle",
          tdClass: "text-left align-middle",
        },
        {
          key: "valor_movimento",
          label: "Valor",
          sortable: false,
          thClass: "text-right align-middle",
          tdClass: "text-right align-middle",
        },
        {
          key: "saldo_apos",
          label: "Saldo após",
          sortable: false,
          thClass: "text-right align-middle",
          tdClass: "text-right align-middle",
        },
        {
          key: "acoes",
          label: "Ações",
          sortable: false,
          thStyle: { width: "120px" },
          thClass: "text-center align-middle coluna-acoes-extrato",
          tdClass: "text-center align-middle coluna-acoes-extrato",
        },
      ],
      isLoading: true,
      selectedPeriodo: "mes",
      periodos: [
        { value: "hoje", text: "Hoje" },
        { value: "ontem", text: "Ontem" },
        { value: "semana", text: "7 dias" },
        { value: "semana_passada", text: "Semana passada" },
        { value: "mes", text: "Este mês" },
        { value: "personalizado", text: "Personalizado" },
      ],
      filtroTipo: "Todos",
      tiposFiltro: ["Todos", "Entrada", "Saída", "Transferência", "Estorno"],
      filtroStatus: "Todos",
      statusFiltro: ["Todos", "Ativa", "Estornada"],
      buscaMovimentoInput: "",
      buscaMovimento: "",
      debounceBuscaTimer: null,
      paginaAtual: 1,
      porPagina: 50,
      opcoesPorPagina: [
        { value: 20, text: "20 por página" },
        { value: 50, text: "50 por página" },
        { value: 100, text: "100 por página" },
      ],
      lancamento: {},
      dataMovimentoOriginalEdicao: null,
      configMoney: settingMoney,
      tiposMovimento: [
        { id: 2, descricao: "Saída" },
        { id: 1, descricao: "Entrada" },
      ],
      bancos: [],
      transferencia: {
        banco: null,
        valor: 0,
        data_transferencia: moment().format("YYYY-MM-DD"),
        observacao: "",
      },
      tipoTransferencia: "contas",
      mostrarTransferencia: false,
      isSavingTransferenciaContas: false,
      isSavingTransferenciaCaixa: false,
      isAtualizandoBanco: false,
      erroTransferenciaCaixa: "",
      transferenciaCaixaPendenteAtualizacao: null,
      isEstornandoTransferenciaCaixa: null,
      saldoAnteriorPeriodo: null,
      dataSaldoAnteriorPeriodo: null,
      alturaUtilExtrato: null,
    };
  },
  components: {
    Plus,
    Money,
    SwapHorizontal,
    FileExcel,
  },
  watch: {
    buscaMovimentoInput(valor) {
      clearTimeout(this.debounceBuscaTimer);
      this.debounceBuscaTimer = setTimeout(() => {
        this.buscaMovimento = valor;
        this.reiniciarPaginacao();
      }, 400);
    },
    filtroTipo() {
      this.reiniciarPaginacao();
    },
    filtroStatus() {
      this.reiniciarPaginacao();
    },
    porPagina() {
      this.reiniciarPaginacao();
    },
    paginaAtual() {
      this.resetarScrollTabela();
    },
    totalPaginas(valor) {
      if (this.paginaAtual > valor) {
        this.paginaAtual = valor;
      }
    },
  },
  methods: {
    atualizarAlturaUtilExtrato() {
      this.$nextTick(() => {
        const pagina = this.$refs.paginaExtrato;
        if (!pagina) return;

        const footerSistema = document.getElementById("kt_footer");
        const contentSistema = document.getElementById("kt_content");
        const paddingInferior = contentSistema
          ? Number.parseFloat(
              window.getComputedStyle(contentSistema).paddingBottom
            ) || 0
          : 0;
        const alturaFooter = footerSistema
          ? footerSistema.getBoundingClientRect().height
          : 0;
        const topoPagina = Math.max(0, pagina.getBoundingClientRect().top);
        const alturaDisponivel = Math.floor(
          window.innerHeight - topoPagina - alturaFooter - paddingInferior
        );

        this.alturaUtilExtrato = `${Math.max(0, alturaDisponivel)}px`;
      });
    },
    resetarScrollTabela() {
      this.$nextTick(() => {
        const areaRolavel = this.$el?.querySelector(
          ".bloco-tabela-extrato .table-responsive"
        );
        if (areaRolavel) areaRolavel.scrollTop = 0;
      });
    },
    reiniciarPaginacao() {
      this.paginaAtual = 1;
      this.resetarScrollTabela();
    },
    dataAberturaConta(banco) {
      if (!banco?.created_at || !moment(banco.created_at).isValid())
        return null;

      return moment(banco.created_at).format("YYYY-MM-DD");
    },
    dataMaisRecente(...datas) {
      return datas.filter(Boolean).sort().pop() || null;
    },
    dataAnteriorAbertura(data, dataMinima) {
      const dataInformada = moment(data, "YYYY-MM-DD", true);

      return (
        Boolean(dataMinima) &&
        dataInformada.isValid() &&
        dataInformada.isBefore(dataMinima, "day")
      );
    },
    parametrosExtrato(inicio = this.data_inicial, fim = this.data_final) {
      return {
        id_banco: this.$route.params.id_banco,
        data_inicial: inicio,
        data_final: fim,
        com_resumo_saldo: true,
      };
    },
    aplicarRespostaExtrato(data) {
      const respostaEstruturada = !Array.isArray(data) && data;
      const movimentacoes = respostaEstruturada
        ? data.movimentacoes || []
        : data || [];

      this.movimentacoes = movimentacoes;
      this.saldoAnteriorPeriodo = respostaEstruturada
        ? Number(data.saldo_anterior) || 0
        : movimentacoes.length
        ? Number(movimentacoes[0].saldo_dia_anterior) || 0
        : 0;
      this.dataSaldoAnteriorPeriodo = respostaEstruturada
        ? data.data_saldo_anterior || null
        : movimentacoes[0]?.data_saldo_dia_anterior || null;
    },
    async carregarBancoAtual() {
      const { data } = await this.$http.post("/bancos/find", {
        id_banco: this.$route.params.id_banco,
      });
      this.banco = data;

      return data;
    },
    async carregarBancoEExtrato(
      inicio = this.data_inicial,
      fim = this.data_final
    ) {
      const [banco, extrato] = await Promise.all([
        this.$http.post("/bancos/find", {
          id_banco: this.$route.params.id_banco,
        }),
        this.$http.post(
          "/bancos/movimentacoes",
          this.parametrosExtrato(inicio, fim)
        ),
      ]);

      this.banco = banco.data;
      this.aplicarRespostaExtrato(extrato.data);
    },
    ehTransferenciaBancoCaixa(item) {
      return Number(item?.transferencia_banco_caixa) === 1;
    },
    ehEstornoTransferenciaBancoCaixa(item) {
      return Number(item?.transferencia_banco_caixa_estorno) === 1;
    },
    ehTransferenciaBancoCaixaEstornada(item) {
      return Number(item?.transferencia_banco_caixa_estornada) === 1;
    },
    podeEstornarTransferenciaBancoCaixa(item) {
      return item?.pode_estornar === true;
    },
    podeEditarMovimento(item) {
      return item?.pode_editar === true;
    },
    tipoMovimento(item) {
      return (
        item?.tipo_extrato ||
        (Number(item?.tipo_movimento) === 1 ? "Entrada" : "Saída")
      );
    },
    statusMovimento(item) {
      return (
        item?.status_extrato ||
        (this.ehTransferenciaBancoCaixaEstornada(item) ? "Estornada" : "Ativa")
      );
    },
    siglaTipo(item) {
      return (
        {
          Entrada: "E",
          Saída: "S",
          Transferência: "T",
          Estorno: "R",
        }[this.tipoMovimento(item)] || "?"
      );
    },
    siglaStatus(item) {
      return this.statusMovimento(item) === "Estornada" ? "E" : "A";
    },
    classeTipo(item) {
      return `badge-tipo--${this.tipoMovimento(item)
        .toLowerCase()
        .replace("ê", "e")
        .replace("í", "i")}`;
    },
    classeStatus(item) {
      return this.statusMovimento(item) === "Estornada"
        ? "badge-status--estornada"
        : "badge-status--ativa";
    },
    detalheMovimento(item) {
      const documento =
        item.documento_conta_receber || item.documento_conta_pagar;
      const historico =
        item.historico_conta_receber || item.historico_conta_pagar;

      return [documento, historico].filter(Boolean).join(" · ");
    },
    descricaoApresentacao(item) {
      return String(item?.descricao || "").replace(
        /Movimento do Caixa/gi,
        "Caixa"
      );
    },
    classeLinhaExtrato(item) {
      return item?.eh_fechamento_diario ? "linha-fechamento-diario" : "";
    },
    dataHoraEfetivaMovimento(item) {
      if (item?.data_hora_efetiva) return item.data_hora_efetiva;
      if (!item?.data_movimento) return "";

      const dataMovimento = moment(item.data_movimento);
      if (!dataMovimento.isValid()) return "";
      if (dataMovimento.format("HH:mm:ss") !== "00:00:00") {
        return dataMovimento.format("YYYY-MM-DD HH:mm:ss");
      }

      const criadoEm = moment(item.criado_em);
      if (
        criadoEm.isValid() &&
        criadoEm.format("YYYY-MM-DD") === dataMovimento.format("YYYY-MM-DD")
      ) {
        return criadoEm.format("YYYY-MM-DD HH:mm:ss");
      }

      return dataMovimento.format("YYYY-MM-DD");
    },
    formatDataHoraMovimento(item) {
      const dataHoraEfetiva = this.dataHoraEfetivaMovimento(item);
      if (!dataHoraEfetiva) return "—";

      const formato =
        dataHoraEfetiva.length > 10 ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY";
      return moment(dataHoraEfetiva).format(formato);
    },
    async estornarTransferenciaCaixa(item) {
      if (item?.pode_estornar !== true || this.isEstornandoTransferenciaCaixa !== null) return;
      if (item?.origem_movimento && item.origem_movimento !== "transferencia_banco_caixa") {
        if (["conta_receber", "conta_pagar"].includes(item.origem_movimento)) {
          return this.getRequestAdmin(() => this.estornarMovimentoOrigem(item));
        }
        return this.estornarMovimentoOrigem(item);
      }
      if (
        this.isEstornandoTransferenciaCaixa !== null ||
        !this.podeEstornarTransferenciaBancoCaixa(item) ||
        !item.id_financeiro
      )
        return;

      this.isEstornandoTransferenciaCaixa = item.id_financeiro;
      let estornoConfirmado = false;

      try {
        const resultado = await this.$swal.fire({
          icon: "warning",
          title: "Estornar transferência?",
          text: `Confirma o estorno da transferência de R$ ${this.numberToReal(
            item.valor_movimento
          )} para o Caixa? O valor retornará ao banco e será registrada uma saída compensatória no Caixa.`,
          showCancelButton: true,
          confirmButtonText: "Estornar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#f64e60",
        });

        if (!resultado.isConfirmed) return;

        await this.$http.post(
          `/financeiro/transferencia-banco-caixa/${item.id_financeiro}/estornar`
        );
        estornoConfirmado = true;
        this.$toast.success("Transferência estornada com sucesso!");

        await this.carregarBancoEExtrato();
      } catch (error) {
        if (estornoConfirmado) {
          this.$toast.warning(
            "A transferência foi estornada, mas não foi possível atualizar o saldo e o extrato. Atualize a tela."
          );
        } else if (!error.response) {
          this.$toast.error("Não foi possível estornar a transferência.");
        }
      } finally {
        this.isEstornandoTransferenciaCaixa = null;
      }
    },
    async estornarMovimentoOrigem(item) {
      if (
        this.isEstornandoTransferenciaCaixa !== null ||
        item?.pode_estornar !== true
      ) return;
      const rotas = {
        transferencia_banco_banco: [
          "/bancos/transferencia-estornar",
          { id_movimento: item.id_movimento },
        ],
        conta_receber: [
          "/contareceber/estornar",
          { contas_receber: [{ id: item.id_conta_receber }] },
        ],
        conta_pagar: [
          "/contapagar/estornar",
          { contas_pagar: [{ id: item.id_conta_pagar }] },
        ],
      };
      const rota = rotas[item.origem_movimento];
      if (!rota) return;
      this.isEstornandoTransferenciaCaixa = item.id_financeiro || item.id_movimento;
      let confirmado = false;
      try {
        const resposta = await this.$swal.fire({
          icon: "warning",
          title: "Estornar movimentação?",
          text: "A operação de origem será estornada, incluindo seus efeitos financeiros.",
          showCancelButton: true,
          confirmButtonText: "Estornar",
          cancelButtonText: "Cancelar",
        });
        if (!resposta.isConfirmed) return;
        const { data } = await this.$http.post(...rota);
        if (data?.status === false) {
          this.$toast.error(data.msg || "Não foi possível estornar a operação.");
          return;
        }
        confirmado = true;
        this.$toast.success("Operação estornada com sucesso!");
        await this.carregarBancoEExtrato();
      } catch (error) {
        if (confirmado) {
          this.$toast.warning(
            "Operação estornada, mas não foi possível atualizar o extrato. Atualize a tela."
          );
        } else {
          this.$toast.error(
            error?.response?.data?.msg || "Não foi possível estornar a operação."
          );
        }
      } finally {
        this.isEstornandoTransferenciaCaixa = null;
      }
    },
    async abrirTransferencia() {
      if (
        !this.banco ||
        this.isAtualizandoBanco ||
        this.isSavingTransferencia ||
        this.transferenciaCaixaPendenteAtualizacao
      )
        return;

      this.isAtualizandoBanco = true;
      try {
        await this.carregarBancoAtual();
        const hoje = moment().format("YYYY-MM-DD");
        this.transferencia = {
          ...this.transferencia,
          data_transferencia: hoje,
        };
        this.mostrarTransferencia = true;
      } catch (error) {
        this.$toast.error("Não foi possível atualizar o saldo da conta.");
      } finally {
        this.isAtualizandoBanco = false;
      }
    },
    selecionarTipoTransferencia(tipo) {
      if (this.tipoTransferencia === tipo) return;

      if (tipo === "caixa") {
        this.transferencia = {
          ...this.transferencia,
          banco: null,
        };
      }
      this.erroTransferenciaCaixa = "";
      this.tipoTransferencia = tipo;
    },
    selecionarTransferenciaCaixa() {
      this.selecionarTipoTransferencia("caixa");
    },
    async abrirTransferenciaCaixa() {
      await this.abrirTransferencia();
      if (!this.mostrarTransferencia) return;

      this.selecionarTransferenciaCaixa();
    },
    salvarTransferenciaAtual() {
      return this.tipoTransferencia === "caixa"
        ? this.salvarTransferenciaCaixa()
        : this.salvarTransferencia();
    },
    async salvarTransferenciaCaixa() {
      // O guard é síncrono: bloqueia outro submit antes da atualização visual do botão.
      if (
        this.isSavingTransferenciaCaixa ||
        this.transferenciaCaixaPendenteAtualizacao
      )
        return;

      const valor = Number(this.transferencia.valor);
      const dataTransferencia = this.transferencia.data_transferencia;
      const descricao = this.transferencia.observacao || "";
      this.erroTransferenciaCaixa = "";

      if (!this.banco?.id_banco) {
        this.erroTransferenciaCaixa = "Conta bancária não encontrada.";
      } else if (!Number.isFinite(valor) || valor <= 0) {
        this.erroTransferenciaCaixa = "Informe um valor maior que zero.";
      } else if (!moment(dataTransferencia, "YYYY-MM-DD", true).isValid()) {
        this.erroTransferenciaCaixa = "Informe uma data válida.";
      } else if (
        this.dataAnteriorAbertura(dataTransferencia, this.dataMinimaBancoAtual)
      ) {
        this.erroTransferenciaCaixa =
          "A data da movimentação não pode ser anterior à abertura da conta.";
      } else if (descricao.length > 140) {
        this.erroTransferenciaCaixa =
          "A observação deve possuir no máximo 140 caracteres.";
      }
      if (this.erroTransferenciaCaixa) return;

      this.isSavingTransferenciaCaixa = true;
      try {
        await this.$http.post("/financeiro/transferencia-banco-caixa", {
          id_banco: this.banco.id_banco,
          valor,
          data_transferencia: dataTransferencia,
          descricao,
        });
        this.transferenciaCaixaPendenteAtualizacao = dataTransferencia;
        this.mostrarTransferencia = false;
        this.transferencia = {
          banco: null,
          valor: 0,
          data_transferencia: moment().format("YYYY-MM-DD"),
          observacao: "",
        };
        this.$toast.success(
          "Transferência para o Caixa realizada com sucesso!"
        );
        await this.atualizarExtratoTransferenciaCaixa();
      } catch (error) {
        const status = error.response?.status;
        const errors = error.response?.data?.errors;
        if (status === 422) {
          this.erroTransferenciaCaixa = errors?.id_banco
            ? "Conta bancária não encontrada."
            : Object.values(errors || {})
                .flat()
                .join(" ") || "Verifique os dados da transferência.";
        } else if (status === 401) {
          this.erroTransferenciaCaixa =
            "Sua sessão expirou. Entre novamente para continuar.";
        } else if (status === 403) {
          this.erroTransferenciaCaixa =
            "Você não tem permissão para realizar esta transferência.";
        } else {
          this.erroTransferenciaCaixa =
            "Não foi possível confirmar a transferência. Confira o extrato antes de tentar novamente.";
        }
      } finally {
        this.isSavingTransferenciaCaixa = false;
      }
    },
    async atualizarExtratoTransferenciaCaixa() {
      const dataTransferencia = this.transferenciaCaixaPendenteAtualizacao;
      if (!dataTransferencia || this.isLoading) return;
      this.isLoading = true;
      // Inclui a nova saída mesmo quando a data escolhida está fora do filtro atual.
      const inicio =
        this.data_inicial && this.data_inicial < dataTransferencia
          ? this.data_inicial
          : dataTransferencia;
      const fim =
        this.data_final && this.data_final > dataTransferencia
          ? this.data_final
          : dataTransferencia;
      try {
        await this.carregarBancoEExtrato(inicio, fim);
        if (inicio !== this.data_inicial || fim !== this.data_final) {
          this.selectedPeriodo = "personalizado";
        }
        this.data_inicial = inicio;
        this.data_final = fim;
        this.atualizarTituloCard();
        this.transferenciaCaixaPendenteAtualizacao = null;
      } catch (error) {
        // A transferência já foi confirmada; este retry executa somente consultas.
      } finally {
        this.isLoading = false;
      }
    },
    exportarExtratoXLS() {
      const dados = this.tableMovimentacoes.map((item) => {
        return {
          "Data/Hora": this.formatDataHoraMovimento(item),
          Tipo: this.tipoMovimento(item),
          Status: this.statusMovimento(item),
          Descrição: this.descricaoApresentacao(item),
          Origem: item.origem ?? "",
          Destino: item.destino ?? "",
          Documento:
            item.documento_conta_receber ?? item.documento_conta_pagar ?? "",
          Histórico:
            item.historico_conta_receber ?? item.historico_conta_pagar ?? "",
          Valor: `${
            Number(item.tipo_movimento) === 1 ? "+" : "-"
          } ${this.numberToReal(item.valor_movimento ?? 0)}`,
          "Saldo após": this.numberToReal(item.saldo_apos ?? 0),
        };
      });

      const ws = XLSX.utils.json_to_sheet(dados);

      // (Opcional) larguras de coluna aproximadas
      ws["!cols"] = [
        { wch: 18 },
        { wch: 14 },
        { wch: 12 },
        { wch: 40 },
        { wch: 24 },
        { wch: 24 },
        { wch: 18 },
        { wch: 35 },
        { wch: 16 },
        { wch: 16 },
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Extrato");

      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const nomeArquivo = `extrato_bancario_${
        this.banco?.nome || "banco"
      }.xlsx`;
      saveAs(blob, nomeArquivo);
    },
    editarMovimento(item) {
      if (!this.podeEditarMovimento(item)) return;

      this.lancamento = { ...item };
      this.dataMovimentoOriginalEdicao = item.data_movimento;
      this.lancamento.valor = item.valor_movimento;
      this.lancamento.tipo = item.tipo_movimento;
      this.$root.$emit("bv::toggle::collapse", "sidebar-movimento-fields");
    },
    onPeriodChange() {
      this.reiniciarPaginacao();
      if (this.selectedPeriodo === "personalizado") {
        if (this.periodoPersonalizadoValido()) return this.applyPeriod();
        return;
      }

      return this.applyPeriod();
    },
    onDataPersonalizadaChange() {
      this.reiniciarPaginacao();
      this.selectedPeriodo = "personalizado";
      if (this.periodoPersonalizadoValido()) return this.applyPeriod();
    },
    async salvarTransferencia() {
      if (this.isSavingTransferenciaContas) return;

      if (!this.transferencia.banco) {
        this.$toast.warning("Seleciona a conta para transferência!");
        return;
      }

      const valor = Number(this.transferencia.valor);
      if (!Number.isFinite(valor) || valor <= 0) {
        this.$toast.warning("Informe o valor da transferência!");
        return;
      }

      this.transferencia.data_transferencia =
        this.transferencia.data_transferencia || moment().format("YYYY-MM-DD");

      if (
        this.dataAnteriorAbertura(
          this.transferencia.data_transferencia,
          this.dataMinimaTransferenciaContas
        )
      ) {
        this.$toast.warning(
          "A data da transferência não pode ser anterior à abertura das contas envolvidas."
        );
        return;
      }

      const observacao = (this.transferencia.observacao || "").trim();
      const payload = {
        banco: this.transferencia.banco,
        valor_tranferencia: valor,
        descricao: observacao || "Transferência",
        banco_origem: this.banco.id_banco,
        data_transferencia: this.transferencia.data_transferencia,
      };

      this.isSavingTransferenciaContas = true;
      this.addLoadingToButton("salvarTranferencia");
      let transferenciaConfirmada = false;
      try {
        await this.$http.post("/bancos/transferencia", payload);
        transferenciaConfirmada = true;
        this.$toast.success("Transferência realizada com sucesso!");
        this.transferencia = {
          banco: null,
          valor: 0,
          data_transferencia: moment().format("YYYY-MM-DD"),
          observacao: "",
        };
        await this.carregarBancoEExtrato();
        this.mostrarTransferencia = false;
      } catch (error) {
        if (transferenciaConfirmada) {
          this.$toast.warning(
            "A transferência foi concluída, mas não foi possível atualizar o saldo e o extrato. Atualize a tela."
          );
        } else if (error.response?.status === 422) {
          const errors = error.response?.data?.errors || {};
          this.$toast.warning(
            Object.values(errors).flat().join(" ") ||
              "Verifique os dados da transferência."
          );
        }
      } finally {
        this.isSavingTransferenciaContas = false;
        this.removeLoadingToButton("salvarTranferencia");
      }
    },
    async salvarMovimento() {
      if (!this.banco) {
        this.$toast.warning("Nenhum banco selecionado!");
        return;
      }

      if (this.lancamento.valor <= 0) {
        this.$toast.warning("Informe o valor do movimento!");
        return;
      }

      if (!this.lancamento.tipo) {
        this.$toast.warning("Selecione o tipo do movimento!");
        return;
      }

      const deveValidarData =
        !this.lancamento.id_movimento ||
        this.dataMovimentoFoiAlteradaNaEdicao(this.lancamento.data_movimento);

      if (
        deveValidarData &&
        this.dataAnteriorAbertura(
          this.lancamento.data_movimento,
          this.dataMinimaMovimento
        )
      ) {
        this.$toast.warning(
          this.lancamento.banco_contraparte_id
            ? "A data da transferência não pode ser anterior à abertura das contas envolvidas."
            : "A data da movimentação não pode ser anterior à abertura da conta."
        );
        return;
      }

      this.lancamento.id_banco = this.banco.id_banco;

      this.addLoadingToButton("salvarMovimento");
      let movimentoConfirmado = false;
      try {
        if (this.lancamento.id_movimento) {
          await this.$http.post("/bancos/movimentacao-update", this.lancamento);
          this.$toast.success("Lançamento atualizado com sucesso!");
        }

        if (!this.lancamento.id_movimento) {
          await this.$http.post("/bancos/movimentacao-create", this.lancamento);
          this.$toast.success("Lançamento realizado com sucesso!");
        }
        movimentoConfirmado = true;
        await this.carregarBancoEExtrato();
        this.lancamento = {};
        this.dataMovimentoOriginalEdicao = null;
      } catch (error) {
        if (movimentoConfirmado) {
          this.$toast.warning(
            "A movimentação foi concluída, mas não foi possível atualizar o saldo e o extrato. Atualize a tela."
          );
        }
      }
      this.lancamento = {};
      this.dataMovimentoOriginalEdicao = null;
      this.removeLoadingToButton("salvarMovimento");
      this.$root.$emit("bv::toggle::collapse", "sidebar-movimento-fields");
    },
    periodoPersonalizadoValido() {
      const inicio = moment(this.data_inicial, "YYYY-MM-DD", true);
      const fim = moment(this.data_final, "YYYY-MM-DD", true);

      return inicio.isValid() && fim.isValid() && !inicio.isAfter(fim);
    },
    dataMovimentoFoiAlteradaNaEdicao(novaData) {
      if (!this.dataMovimentoOriginalEdicao) return true;

      return (
        moment(novaData).format("YYYY-MM-DD") !==
        moment(this.dataMovimentoOriginalEdicao).format("YYYY-MM-DD")
      );
    },
    definirDatasPeriodoSelecionado() {
      const currentDate = moment();

      switch (this.selectedPeriodo) {
        case "hoje":
          this.data_inicial = currentDate
            .clone()
            .startOf("day")
            .format("YYYY-MM-DD");
          this.data_final = currentDate
            .clone()
            .endOf("day")
            .format("YYYY-MM-DD");
          break;
        case "ontem":
          this.data_inicial = currentDate
            .clone()
            .subtract(1, "days")
            .startOf("day")
            .format("YYYY-MM-DD");
          this.data_final = currentDate
            .clone()
            .subtract(1, "days")
            .endOf("day")
            .format("YYYY-MM-DD");
          break;
        case "semana":
          this.data_inicial = currentDate
            .clone()
            .subtract(6, "days")
            .format("YYYY-MM-DD");
          this.data_final = currentDate.clone().format("YYYY-MM-DD");
          break;
        case "semana_passada":
          this.data_inicial = currentDate
            .clone()
            .subtract(1, "week")
            .startOf("week")
            .format("YYYY-MM-DD");
          this.data_final = currentDate
            .clone()
            .subtract(1, "week")
            .endOf("week")
            .format("YYYY-MM-DD");
          break;
        case "mes":
          this.data_inicial = currentDate
            .clone()
            .startOf("month")
            .format("YYYY-MM-DD");
          this.data_final = currentDate
            .clone()
            .endOf("month")
            .format("YYYY-MM-DD");
          break;
      }
    },
    atualizarTituloCard() {
      this.titulo_card = `${
        this.banco?.nome || "Conta bancária"
      } - Extrato bancário`;
    },
    applyPeriod() {
      if (!this.selectedPeriodo) return;
      if (this.selectedPeriodo !== "personalizado") {
        this.definirDatasPeriodoSelecionado();
      }
      if (!this.periodoPersonalizadoValido()) return;

      this.atualizarTituloCard();
      return this.filterMovimentacoes();
    },

    async getBanco(id) {
      try {
        const data = await this.carregarBancoAtual();

        this.titulo =
          "Movimentação bancária: " +
          data.nome +
          " " +
          data.agencia +
          "/" +
          data.conta;
      } catch (error) {
        return null;
      }
    },
    async filterMovimentacoes() {
      this.isLoading = true;
      try {
        const { data } = await this.$http.post(
          "/bancos/movimentacoes",
          this.parametrosExtrato()
        );

        this.aplicarRespostaExtrato(data);
      } finally {
        this.isLoading = false;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
    isSavingTransferencia() {
      return (
        this.isSavingTransferenciaContas || this.isSavingTransferenciaCaixa
      );
    },
    dataMinimaBancoAtual() {
      return this.dataAberturaConta(this.banco);
    },
    dataMinimaTransferenciaContas() {
      return this.dataMaisRecente(
        this.dataMinimaBancoAtual,
        this.dataAberturaConta(this.transferencia.banco)
      );
    },
    dataMinimaTransferenciaAtual() {
      return this.tipoTransferencia === "caixa"
        ? this.dataMinimaBancoAtual
        : this.dataMinimaTransferenciaContas;
    },
    dataMinimaMovimento() {
      const bancoContraparte = this.bancos.find(
        (banco) =>
          Number(banco.id_banco) ===
          Number(this.lancamento.banco_contraparte_id)
      );

      return this.dataMaisRecente(
        this.dataMinimaBancoAtual,
        this.dataAberturaConta(bancoContraparte)
      );
    },
    movimentacoesOrdenadas() {
      return [...this.movimentacoes].sort((a, b) => {
        const comparacaoData = this.dataHoraEfetivaMovimento(a).localeCompare(
          this.dataHoraEfetivaMovimento(b)
        );

        return comparacaoData !== 0
          ? comparacaoData
          : Number(a.id_movimento) - Number(b.id_movimento);
      });
    },
    movimentacoesComSaldo() {
      let saldo = this.saldoBasePeriodo;

      return this.movimentacoesOrdenadas.map((movimento) => {
        const valor = Number(movimento.valor_movimento) || 0;
        saldo += Number(movimento.tipo_movimento) === 1 ? valor : -valor;

        return { ...movimento, saldo_apos: saldo };
      });
    },
    movimentacoesOperacionaisPeriodo() {
      return this.movimentacoesOrdenadas.filter(
        (movimento) => Number(movimento.abertura_conta) !== 1
      );
    },
    resumoExtrato() {
      const saldoAnterior = this.saldoBasePeriodo;
      const entradas = this.movimentacoesOperacionaisPeriodo
        .filter((item) => Number(item.tipo_movimento) === 1)
        .reduce(
          (total, item) => total + (Number(item.valor_movimento) || 0),
          0
        );
      const saidas = this.movimentacoesOperacionaisPeriodo
        .filter((item) => Number(item.tipo_movimento) === 2)
        .reduce(
          (total, item) => total + (Number(item.valor_movimento) || 0),
          0
        );

      return {
        saldoAnterior,
        entradas,
        saidas,
        resultadoPeriodo: entradas - saidas,
        quantidadeEntradas: this.movimentacoesOperacionaisPeriodo.filter(
          (item) =>
            Number(item.tipo_movimento) === 1 &&
            Number(item.valor_movimento) !== 0
        ).length,
        quantidadeSaidas: this.movimentacoesOperacionaisPeriodo.filter(
          (item) =>
            Number(item.tipo_movimento) === 2 &&
            Number(item.valor_movimento) !== 0
        ).length,
      };
    },
    classeResultadoPeriodo() {
      if (this.resumoExtrato.resultadoPeriodo > 0)
        return "resumo-card--entrada";
      if (this.resumoExtrato.resultadoPeriodo < 0) return "resumo-card--saida";

      return "resumo-card--anterior";
    },
    sinalResultadoPeriodo() {
      if (this.resumoExtrato.resultadoPeriodo > 0) return "+";
      if (this.resumoExtrato.resultadoPeriodo < 0) return "-";

      return "";
    },
    periodoFormatado() {
      if (!this.periodoPersonalizadoValido()) return "";

      return `${this.formatDate(this.data_inicial)} a ${this.formatDate(
        this.data_final
      )}`;
    },
    rotuloSaldoAnterior() {
      const dataAnterior =
        this.dataSaldoAnteriorPeriodo ||
        this.movimentacoesOrdenadas[0]?.data_saldo_dia_anterior;
      if (!dataAnterior || !moment(dataAnterior).isValid()) {
        return "Saldo anterior";
      }

      return `Saldo em ${moment(dataAnterior).format("DD/MM/YYYY")}`;
    },
    detalheSaldoFinal() {
      if (!moment(this.data_final, "YYYY-MM-DD", true).isValid()) return "";

      return `Em ${this.formatDate(this.data_final)}`;
    },
    saldoBasePeriodo() {
      if (this.saldoAnteriorPeriodo !== null) {
        return Number(this.saldoAnteriorPeriodo) || 0;
      }

      return this.movimentacoesOrdenadas.length > 0
        ? Number(this.movimentacoesOrdenadas[0].saldo_dia_anterior) || 0
        : 0;
    },
    movimentacoesParaExibicao() {
      return this.movimentacoesComSaldo;
    },
    tableMovimentacoes() {
      const termo = this.buscaMovimento.toLocaleLowerCase("pt-BR");

      return this.movimentacoesParaExibicao.filter((item) => {
        if (
          this.filtroTipo !== "Todos" &&
          this.tipoMovimento(item) !== this.filtroTipo
        )
          return false;
        if (
          this.filtroStatus !== "Todos" &&
          this.statusMovimento(item) !== this.filtroStatus
        )
          return false;
        if (!termo) return true;

        return [
          this.descricaoApresentacao(item),
          item.documento_conta_receber,
          item.documento_conta_pagar,
          item.historico_conta_receber,
          item.historico_conta_pagar,
          item.origem,
          item.destino,
        ].some((valor) =>
          String(valor || "")
            .toLocaleLowerCase("pt-BR")
            .includes(termo)
        );
      });
    },
    totalPaginas() {
      return Math.max(
        1,
        Math.ceil(this.tableMovimentacoes.length / this.porPagina)
      );
    },
    movimentacoesPaginadas() {
      const inicio = (this.paginaAtual - 1) * this.porPagina;

      return this.tableMovimentacoes.slice(inicio, inicio + this.porPagina);
    },
    primeiroRegistroPagina() {
      return this.tableMovimentacoes.length === 0
        ? 0
        : (this.paginaAtual - 1) * this.porPagina + 1;
    },
    ultimoRegistroPagina() {
      return Math.min(
        this.paginaAtual * this.porPagina,
        this.tableMovimentacoes.length
      );
    },
    itensTabelaExtrato() {
      const saldosFechamento = this.movimentacoesComSaldo.reduce(
        (saldos, movimento) => {
          const dataMovimento = moment(
            this.dataHoraEfetivaMovimento(movimento)
          );
          if (dataMovimento.isValid()) {
            saldos.set(
              dataMovimento.format("YYYY-MM-DD"),
              movimento.saldo_apos
            );
          }

          return saldos;
        },
        new Map()
      );
      const indicesMovimentos = new Map(
        this.tableMovimentacoes.map((movimento, index) => [
          movimento.id_movimento,
          index,
        ])
      );

      return this.movimentacoesPaginadas.reduce((linhas, movimento) => {
        const dataMovimento = moment(this.dataHoraEfetivaMovimento(movimento));
        const indiceMovimento = indicesMovimentos.get(movimento.id_movimento);
        const movimentoSeguinte =
          this.tableMovimentacoes[indiceMovimento + 1] || null;
        const dataMovimentoSeguinte = movimentoSeguinte
          ? moment(this.dataHoraEfetivaMovimento(movimentoSeguinte))
          : null;
        const terminaDia =
          dataMovimento.isValid() &&
          (!dataMovimentoSeguinte ||
            !dataMovimentoSeguinte.isValid() ||
            !dataMovimento.isSame(dataMovimentoSeguinte, "day"));

        linhas.push(movimento);

        if (terminaDia) {
          const chaveData = dataMovimento.format("YYYY-MM-DD");
          linhas.push({
            id_movimento: `saldo-${chaveData}`,
            eh_fechamento_diario: true,
            descricao: `Saldo em ${dataMovimento.format("DD/MM/YYYY")}`,
            saldo_apos: saldosFechamento.get(chaveData),
          });
        }

        return linhas;
      }, []);
    },
  },
  async mounted() {
    window.addEventListener("resize", this.atualizarAlturaUtilExtrato);
    this.atualizarAlturaUtilExtrato();
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    const currentDate = moment();
    const monthStart = currentDate
      .clone()
      .startOf("month")
      .format("YYYY-MM-DD");
    const monthEnd = currentDate.clone().endOf("month").format("YYYY-MM-DD");

    this.data_inicial = monthStart;
    this.data_final = monthEnd;

    await this.getBanco(this.$route.params.id_banco);
    this.atualizarTituloCard();

    await this.filterMovimentacoes();

    this.bancos = await this.getBancosByEmpresa();
    this.atualizarAlturaUtilExtrato();
  },
  beforeDestroy() {
    clearTimeout(this.debounceBuscaTimer);
    window.removeEventListener("resize", this.atualizarAlturaUtilExtrato);
  },
};
</script>

<style scoped>
.extrato-bancario {
  border: 1px solid #e4e9f2;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(30, 43, 79, 0.05);
}

.pagina-extrato-bancario {
  width: 100%;
}

.pagina-extrato-bancario,
.extrato-bancario,
.extrato-bancario ::v-deep .card-body,
.bloco-listagem-extrato,
.bloco-tabela-extrato {
  min-width: 0;
  max-width: 100%;
}

.extrato-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding-bottom: 10px;
}

.extrato-identificacao {
  min-width: 220px;
  flex: 1;
}

.extrato-titulo {
  margin: 10px 0 0;
  color: #1e2d50;
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.4;
}

.btn-voltar {
  padding: 6px 11px;
  border: 1px solid var(--primary);
  border-radius: 5px;
  background: #fff;
  color: var(--primary);
  font-size: 0.875rem;
  font-weight: 600;
}

.btn-voltar:hover {
  background: rgba(246, 78, 96, 0.08);
}

.extrato-subtitulo {
  color: #53617c;
  font-size: 0.95rem;
  font-weight: 600;
}

.extrato-periodo {
  margin-top: 2px;
  color: #7b879f;
  font-size: 0.8rem;
}

.saldo-atual-conta {
  display: flex;
  flex-direction: column;
  min-width: 150px;
  padding: 10px 14px;
  border-left: 3px solid #2e72c4;
  background: #f7faff;
  color: #65728d;
  font-size: 0.78rem;
}

.saldo-atual-conta strong {
  color: #1e2d50;
  font-size: 1.1rem;
  white-space: nowrap;
}

.acoes-conta-bancaria {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.acoes-conta-bancaria .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 38px;
  white-space: nowrap;
}

.tipo-transferencia {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border: 2px solid #e4e9f2;
  border-radius: 5px;
}

.tipo-transferencia .btn:first-child {
  border-radius: 5px 0 0 5px;
}

.tipo-transferencia .btn:last-child {
  margin-left: -1px;
  border-radius: 0 5px 5px 0;
}

.resumo-extrato {
  margin-bottom: 0;
}

.resumo-extrato > div {
  margin-bottom: 8px;
}

.resumo-card {
  display: flex;
  align-items: center;
  min-height: 76px;
  padding: 8px 12px;
  border: 1px solid #e4e9f2;
  border-radius: 7px;
  background: #fff;
}

.resumo-icone {
  display: inline-flex;
  flex: 0 0 36px;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-right: 12px;
  border-radius: 50%;
  background: #edf1f7;
  color: #697791;
  font-size: 1.3rem;
  font-weight: 700;
}

.resumo-label {
  color: #33415f;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.15;
}

.resumo-valor {
  margin: 2px 0;
  color: #1e2d50;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.resumo-detalhe {
  color: #77829d;
  font-size: 0.75rem;
  line-height: 1.15;
}

.resumo-card--entrada {
  border-color: #c9efdc;
  background: #f8fdfa;
}

.resumo-card--entrada .resumo-icone {
  background: #d9f7e7;
  color: #16a765;
}

.resumo-card--entrada .resumo-valor {
  color: #169b5c;
}

.resumo-card--saida {
  border-color: #ffd6d6;
  background: #fffafa;
}

.resumo-card--saida .resumo-icone {
  background: #ffe0e0;
  color: #ed3e3e;
}

.resumo-card--saida .resumo-valor {
  color: #df2f2f;
}

.filtros-extrato {
  padding: 8px 0 6px;
  border-top: 1px solid #e5eaf1;
  border-bottom: 1px solid #e5eaf1;
}

.lista-extrato-cabecalho h4 {
  margin: 0 0 14px;
  color: #263653;
  font-size: 1rem;
  font-weight: 700;
}

.filtros-extrato ::v-deep .form-group {
  margin-bottom: 0;
}

.filtros-extrato ::v-deep label {
  color: #34415d;
  font-size: 0.73rem;
  font-weight: 600;
  line-height: 1.1;
  margin-bottom: 3px;
}

.filtros-extrato ::v-deep .form-control,
.filtros-extrato ::v-deep .custom-select {
  height: 34px;
  font-size: 0.82rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.lista-extrato-cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 14px;
  border-bottom: 1px solid #dce2eb;
  color: #34415d;
}

.lista-extrato-cabecalho h4 {
  margin: 0;
}

.lista-extrato-cabecalho h4 span {
  color: #73809a;
  font-weight: 400;
}

.bloco-listagem-extrato {
  margin-top: 8px;
  overflow: hidden;
  border: 1px solid #dce2eb;
  border-radius: 7px;
  background: #fff;
}

.bloco-tabela-extrato ::v-deep .table-responsive {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  max-height: clamp(520px, 72vh, 900px);
  margin-bottom: 0;
  overflow: auto;
}

.tabela-extrato ::v-deep thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  border-top: 0;
  border-bottom: 1px solid #dce2eb;
  background: #f1f4f8;
  color: #34415d;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 0.55rem 0.6rem;
  vertical-align: middle;
  white-space: nowrap;
}

.tabela-extrato ::v-deep table {
  min-width: 1120px;
  margin-bottom: 0;
}

.tabela-extrato ::v-deep .coluna-marcadores-extrato {
  min-width: 105px;
  white-space: nowrap;
}

.tabela-extrato ::v-deep .coluna-data-extrato {
  position: sticky;
  left: 0;
  z-index: 1;
  min-width: 140px;
  background: #fff;
  box-shadow: 1px 0 0 #dce2eb;
}

.tabela-extrato ::v-deep thead th.coluna-data-extrato {
  z-index: 3;
  background: #f1f4f8;
}

.tabela-extrato ::v-deep .coluna-acoes-extrato {
  position: sticky;
  right: 0;
  z-index: 2;
  width: 120px;
  min-width: 120px;
  white-space: nowrap;
  background: #fff;
  box-shadow: -1px 0 0 #dce2eb;
}

.tabela-extrato ::v-deep thead th.coluna-acoes-extrato {
  z-index: 3;
  background: #f1f4f8;
}

.tabela-extrato ::v-deep tr:hover td.coluna-acoes-extrato,
.tabela-extrato ::v-deep tr:hover td.coluna-data-extrato {
  background: #e4e6ef;
}

.tabela-extrato ::v-deep tbody td {
  border-top: 1px solid #e5eaf1;
  color: #34415d;
  font-size: 0.84rem;
  line-height: 1.25;
  padding: 0.42rem 0.6rem;
  vertical-align: middle;
}

.badge-extrato {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;
}

.marcadores-extrato {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.badge-tipo--entrada,
.badge-status--ativa {
  background: #dcf8e8;
  color: #148a51;
}

.badge-tipo--saida,
.badge-status--estornada {
  background: #ffe3e3;
  color: #d72d39;
}

.badge-tipo--transferencia {
  background: #eee6ff;
  color: #7146c7;
}

.badge-tipo--estorno {
  background: #fff0d6;
  color: #c46a00;
}

.descricao-principal,
.valor-movimento {
  font-weight: 600;
}

.valor-movimento,
.saldo-movimento {
  white-space: nowrap;
}

.descricao-detalhe {
  margin-top: 1px;
  color: #7c879f;
  font-size: 0.72rem;
}

.descricao-fechamento {
  color: #405173;
  font-weight: 700;
}

.tabela-extrato ::v-deep .linha-fechamento-diario td {
  background: #eef3f9;
  border-top: 2px solid #ccd7e5;
  color: #405173;
  font-weight: 600;
}

.tabela-extrato ::v-deep .linha-fechamento-diario td.coluna-data-extrato,
.tabela-extrato ::v-deep .linha-fechamento-diario td.coluna-acoes-extrato {
  background: #eef3f9;
}

.rodape-tabela-extrato {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 16px;
  border-top: 1px solid #dce2eb;
  background: #f8fafc;
}

.rodape-registros {
  color: #65718a;
  font-size: 0.82rem;
}

.rodape-paginacao {
  display: flex;
  align-items: center;
  gap: 12px;
}

.seletor-por-pagina {
  width: 138px;
}

.rodape-paginacao ::v-deep .pagination {
  margin-bottom: 0;
}

.acao-indisponivel {
  color: #98a2b8;
}

.estado-vazio {
  padding: 28px 16px;
  color: #67738d;
  text-align: center;
}

.text-right {
  text-align: right;
}

.btn-acao-movimento {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 28px;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  white-space: nowrap;
}

.bloco-tabela-extrato [data-testid="saldo-atual-final"] {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

@media (max-width: 1199.98px) {
  .extrato-header {
    flex-direction: column;
  }

  .acoes-conta-bancaria {
    justify-content: flex-start;
  }

  .saldo-atual-conta {
    border-left: 0;
    border-top: 3px solid #2e72c4;
  }
}

@media (min-width: 1200px) and (min-height: 820px) {
  .pagina-extrato-bancario {
    display: flex;
    flex-direction: column;
    height: var(--altura-util-extrato, auto);
    min-height: 0;
    overflow: hidden;
  }

  .extrato-bancario {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
    margin-bottom: 0;
  }

  .extrato-bancario ::v-deep .card-body {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
  }

  .extrato-header,
  .resumo-extrato,
  .filtros-extrato,
  .lista-extrato-cabecalho,
  .rodape-tabela-extrato {
    flex-shrink: 0;
  }

  .bloco-listagem-extrato,
  .bloco-tabela-extrato {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
  }

  .bloco-tabela-extrato ::v-deep .table-responsive {
    flex: 1 1 auto;
    min-height: 0;
    max-height: none;
  }
}

@media (max-width: 767.98px) {
  .filtros-extrato ::v-deep .form-group {
    margin-bottom: 8px;
  }

  .bloco-tabela-extrato ::v-deep .table-responsive {
    max-height: 70vh;
  }

  .tabela-extrato ::v-deep .coluna-acoes-extrato {
    position: static;
  }

  .acoes-conta-bancaria,
  .acoes-conta-bancaria .btn {
    width: 100%;
  }

  .lista-extrato-cabecalho {
    align-items: flex-start;
    flex-direction: column;
  }

  .rodape-tabela-extrato,
  .rodape-paginacao {
    align-items: stretch;
    flex-direction: column;
  }

  .seletor-por-pagina {
    width: 100%;
  }
}
</style>
